import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div id="home" className="container">
      <div className="row justify-content-center align-items-center h-80vh">
        <div className="col-lg-6 col-md-8 col-sm-12">
          <div className="card m-5 p-5 text-center">
            <p className="fs-2">
              Welcome to <strong>Shop_Kart</strong>
            </p>
            <p className="fs-5">please select an option below</p>
            <div>
              <Link to="/register">
                <button className="btn btn-primary ms-2 ">Register</button>
              </Link>
              <Link to="/login">
                <button className="btn btn-primary ms-2 mt-1">Login</button>
              </Link>
              <Link to="/explore">
                <button className="btn btn-primary ms-2 mt-1">
                  Browse Products
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
